import { withRouter } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary } from 'bernie-view';

import { BadgeModel, PriceViewModel } from 'models/common';
import { PriceBreakDownViewModel, RecentlyViewedModel } from 'models';

import { UitkBadge, UitkBadgeTheme } from 'uitk-react-badge';
import { UitkPrimaryButton } from 'uitk-react-button';

import { Price } from 'components/common/pricing/price';

export interface PriceAndSupportingMessagesContainerProps {
  secondaryCardMessage?: string;
  price?: PriceViewModel;
  supportingMessages?: string[];
  viewSmall: boolean;
  wrapPrice: boolean;
  priceFontWeight: string;
  hotelId?: number;
  secondary?: BadgeModel;
  recentlyViewed?: RecentlyViewedModel;
  isDatelessPdp?: boolean;
  priceBreakDownModel: PriceBreakDownViewModel[];
  infositeUrl?: string;
  excludePriceBreakDownLink?: boolean;
  history?: {
    push: (submitUrl: string) => void;
  };
}

export const PriceAndSupportingMessagesContainer: React.FunctionComponent<PriceAndSupportingMessagesContainerProps> = withRouter(
  ({
    secondaryCardMessage,
    supportingMessages,
    price,
    viewSmall,
    wrapPrice,
    priceFontWeight,
    hotelId,
    secondary,
    recentlyViewed,
    isDatelessPdp,
    priceBreakDownModel,
    infositeUrl,
    excludePriceBreakDownLink,
    history
  }) => {
    const ButtonTracked = ClickTracker(UitkPrimaryButton);
    const buttonLabel = priceBreakDownModel && priceBreakDownModel.length > 0 && priceBreakDownModel[0].bookingLabel;
    const navigateToPDP = () => {
      history.push(infositeUrl);
    };
    const extendedChildActions = (options: any): React.ReactNode => (
      <ButtonTracked
        href={infositeUrl}
        isFullWidth={true}
        onClick={navigateToPDP}
        rfrr="PriceBreakDown.ViewHotel"
        linkName={priceBreakDownModel[0].bookingLabel}
        data-stid="priceBreakDown-view-hotel"
        {...(options || {})}
      >
        {priceBreakDownModel[0].bookingLabel}
      </ButtonTracked>
    );
    const priceCommonProps = {
      price,
      hotelId,
      priceFontWeight,
      recentlyViewed,
      messages: supportingMessages,
      priceBreakDownModel,
      childActions: buttonLabel ? extendedChildActions : null,
      excludePriceBreakDownLink
    };

    if (isDatelessPdp) {
      return null;
    }
    if (viewSmall) {
      return (
        <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink listing__pricing">
          <ErrorBoundary label="hotel.search.listing.price">
            {secondaryCardMessage && (
              <span className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900">{secondaryCardMessage}</span>
            )}
            <Price className="listing__price" wrapPrice={wrapPrice} {...priceCommonProps} />
          </ErrorBoundary>
        </div>
      );
    } else {
      return (
        <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink">
          {secondary && (secondary.text || secondary.icon) && <UitkBadge theme={UitkBadgeTheme[secondary.theme]} text={secondary.text} />}
          {secondaryCardMessage && (
            <div className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900 all-t-margin-one">
              {secondaryCardMessage}
            </div>
          )}{' '}
          <ErrorBoundary label="hotel.search.listing.price">
            <Price className="listing__price all-t-padding-half" {...priceCommonProps} />
          </ErrorBoundary>
        </div>
      );
    }
  }
);
